<template>
  <div class="crud_form_wrapper">
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.specialization_edit") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #724c80">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>

    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <base-image-upload-input
            col="12"
            identifier="admin_image"
            :placeholder="$t('PLACEHOLDERS.specialization_icon')"
            :preSelectedImage="data.icon.path"
            @selectImage="selectImage"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameAr')"
            v-model.trim="data.name_ar"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameEn')"
            v-model.trim="data.name_en"
            required
          />

          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "EditSpecialization",

  data() {
    return {
      isWaitingRequest: false,
      data: {
        icon: { file: null, path: null },
        name_ar: "",
        name_en: "",
        active: true,
      },
    };
  },

  methods: {
    selectImage(selectedImage) {
      this.data.icon = selectedImage;
    },

    validateFormInputs() {
      this.isWaitingRequest = true;
      this.submitForm();
    },

    async submitForm() {
      const REQUEST_DATA = new FormData();
      if (this.data.name_ar) {
        REQUEST_DATA.append("name[ar]", this.data.name_ar);
      }
      if (this.data.name_en) {
        REQUEST_DATA.append("name[en]", this.data.name_en);
      }
      if (this.data.icon.file) {
        REQUEST_DATA.append("icon", this.data.icon.file);
      }
      REQUEST_DATA.append("_method", "PUT");

      try {
        await this.$axios({
          method: "POST",
          url: `specializations/${this.$route.params.id}`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.editedSuccessfully"));
        this.$router.push({ path: "/specialization/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },

    async showData() {
      try {
        const res = await this.$axios({
          method: "GET",
          url: `specializations/${this.$route.params.id}`,
        });
        const specialization = res.data.data.Specialization;
        this.data.name_ar = specialization.name_ar;
        this.data.name_en = specialization.name_en;
        this.data.icon.path = specialization.icon;
      } catch (error) {
        this.isWaitingRequest = false;
        console.log(error?.response?.data?.message);
      }
    },
  },

  created() {
    this.showData();
  },
};
</script>
